export default __webpack_public_path__ + "static/media/undraw_real.71d2decf.svg";